"use strict";
/**
 * @file Created on 08.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NSimDummyProduct =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NSimDummyProduct, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param productExternalId
   * @param promoPrice
   * @param promoVolume
   * @param promoPurchasePrice
   */
  function NSimDummyProduct(productId, productName, productExternalId, promoPrice, promoVolume, promoPurchasePrice) {
    var _this;

    _classCallCheck(this, NSimDummyProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimDummyProduct).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.promoPrice = promoPrice;
    _this.promoVolume = promoVolume;
    _this.promoPurchasePrice = promoPurchasePrice;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NSimDummyProduct, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NSimDummyProduct(mat.productId, mat.productName, mat.productExternalId, mat.promoPrice, mat.promoVolume, mat.promoPurchasePrice);
    }
  }]);

  return NSimDummyProduct;
}(NotificationDoc_1.NotificationDoc);

exports.NSimDummyProduct = NSimDummyProduct;

NSimDummyProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NSimDummyProduct.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.str('productExternalId'),
    promoPrice: builder.bigNum('promoPrice'),
    promoVolume: builder.bigNum('promoVolume'),
    promoPurchasePrice: builder.bigNum('promoPurchasePrice')
  };
}();